/***
 * Created on 2023/8/21
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/
import React, {useState} from 'react';
import ic_laptop_svg from '../../../../static/img/utils/ic-laytop.svg';
import {useUA} from "use-ua-parser-js";
import {useTranslation} from "react-i18next";
import {getCookie} from "../../../../service/common";
import {Tooltip} from "react-tooltip";
import {useMutation, useQueryClient} from "@tanstack/react-query";
import {apiDelete, apiPut} from "../../../../service/api";
import {formatDate, formatTime} from "../../../../service/datetime";

function TrustDeviceRow({fieldList, item}) {
    const { t } = useTranslation();
    const os = useUA(item);
    const queryClient = useQueryClient();

    const deleteMutation = useMutation({
        mutationFn: async (data) => apiDelete(`/ajax/trust_device`, data),
        onSuccess: data => {
            queryClient.invalidateQueries({
                queryKey: ['get_trusted_device']
            })
        },
        onError: (error, variables, context) => {
            console.error(error);
        }
    });

    const onDelete = async (client_key) => {
        await deleteMutation.mutate({
            client_key
        });
    }

    return (
        <div className="flex-table-row">
            <div className={`flex-table__cell flex-table-row__cell w-${fieldList[0].size}`} data-label={fieldList[0].name}>
                <div className="comp-group-info">
                    <div className="group-info--img round-full">
                        <img src={ic_laptop_svg}/>
                        {/*<img src="static/img/utils/ic--device--monitor.svg"/>*/}
                    </div>
                    <div className="group-info--detail">
                        <div className="group-info--detail__main-text">
                            { item?.display_device_name }
                            { item?.user_trust_key && item.user_trust_key === getCookie('client_key') &&
                                <div className="comp-tag mt-4">
                                    <div className="q-tag q-tag--tiny">
                                        <span className="tag__label !text-13">{t('@This Device@')}</span>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
            <div className={`flex-table__cell flex-table-row__cell w-${fieldList[1].size}`} data-label={fieldList[1].name}>
                <span className="cell-text">
                    {item?.name}
                </span>
            </div>
            <div className={`flex-table__cell flex-table-row__cell w-${fieldList[2].size}`} data-label={fieldList[2].name}><span
                className="cell-text">{item?.display_domain}</span></div>
            <div className={`flex-table__cell flex-table-row__cell w-${fieldList[3].size}`} data-label={fieldList[3].name}>
                <div className="cell-text">
                    <a href="#" data-tooltip-id={item._id} data-tooltip-content={`${t('@Based on IP:@')} ${item?.remote_ip}`}>{item?.location?.country ? t(`@${item.location.country}@`) : ""}</a>
                     <Tooltip id={item._id} />
                </div>
                <div className="cell-text color-dark-gray">{`${formatDate(t, item.added_on, true)} ${formatTime(item.added_on)}`}</div>
            </div>
            <div className={`flex-table__cell flex-table-row__cell w-${fieldList[4].size}`} data-label={fieldList[4].name}>
                <button className="q-btn q-btn--default btn-small btn-rounded-full min-w-0 !pl-18 !pr-18 !color-red"
                        onClick={() => onDelete(item.user_trust_key)}>
                    {t('@Remove@')}
                </button>
            </div>
        </div>
    );
}

export default TrustDeviceRow;